import { createSlice } from "@reduxjs/toolkit";
//constants
import {
  MODE_TYPES
} from "../../Common/constants/layout";

export interface LayoutState {
  modetype: MODE_TYPES.LIGHT| MODE_TYPES.DARK ;
}

export const initialState: LayoutState = {
  modetype: MODE_TYPES.LIGHT
};

const LayoutSlice = createSlice({
  name: 'LayoutSlice',
  initialState,
  reducers: {
    changeModeAction(state: any, action :any) {
      state.modetype = action.payload;
    }
  }
});

export const {
  changeModeAction
} = LayoutSlice.actions;

export default LayoutSlice.reducer;